"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStyles = function (props) {
    return {
        root: {
            padding: 2,
            outline: 'none'
        },
        tableCell: {
            padding: 0
        }
    };
};
//# sourceMappingURL=Grid.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/utilities/grid/Grid.styles.js
// module id = 1710
// module chunks = 0